const voucherCodeCorrect = (state = null, action) => {
    switch(action.type) {
        case 'voucherCodeCorrect':
            return action.payload;
        default:
            return state;
    }
}

export default voucherCodeCorrect;